export interface ServiceInventoryState {
  items: { [key: string]: ServiceInventoryItem };
  loading: boolean;
  error?: string;
}

export interface ServiceInventoryItem {
  key: string; // Unique identifier (e.g., 'savings', 'spending')
  state: ServiceState;
  route?: string; // Optional routing information
}

export interface ServiceInventoryPayload {
  payload: { items: ServiceInventoryItem[] };
}

export enum ServiceState {
  INITIAL = 'INITIAL',
  PENDING = 'PENDING',
  COMPLETE = 'COMPLETE',
  ERROR = 'ERROR',
  MAINTENANCE = 'MAINTENANCE',
  UPLOAD = 'UPLOAD',
  READY = 'READY',
  INACTIVE = 'INACTIVE',
  ACTION = 'ACTION',
  REVIEW = 'REVIEW',
}

